import React, { useState, useContext, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { Button, List, ListItem, TextField } from "@material-ui/core";
import { trimEmptyLines } from '../helpers/constants';

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
        flexDirection: "column",
        display: "flex",
        overflowY: "auto",
        padding: 0,
        width: '100%'
    },
    date_format: {
        padding: "0 !important",
    },
    text_filed_container: {
        width: '100%'
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
}));

export default function ProjectPropertiesForm(props) {
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const project = props.project;
    const saveProject = props.saveProject;

    const [formData, setFormData] = useState(convertToFormData(project));

    useEffect(() => {
        setFormData(convertToFormData(project));
    }, [JSON.stringify(project)]);

    // convert data as received from API into values suitable to form
    function convertToFormData(project) {
        const formData = {
            Date: project.Date ? new Date(parseInt(project.Date * 1000)) : new Date(),
            Name: project.Name || "",
            Description: project.Description || "",
        }
        return formData;
    }

    // convert form values into values suitable to API
    function convertToSubmitData(formData) {
        const submitData = {
            Date: new Date(formData.Date).getTime() / 1000,
            Name: trimEmptyLines(formData.Name),
            Description: trimEmptyLines(formData.Description)
        }
        return submitData;
    }

    const onFormSubmitted = (e) => {
        e.preventDefault();
        submitForm(formData);
    }

    const onDateChanged = (date) => {
        setFormData({...formData, Date: date});
        submitForm({...formData, Date: date })
    }    

    function submitForm(data)
    {
        const submitData = convertToSubmitData(data);
        saveProject(submitData);
    }


    return (
        <div className={classes.root}>
            <form className={classes.form} noValidate autoComplete="off" onSubmit={onFormSubmitted}>
                <List>
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    disabled = {!project.IsOwner}
                                    required
                                    label={s.date}
                                    size="small"
                                    format={s.common.dateFormatJS}
                                    className={`${classes.text_filed_container} ${classes.date_format}`}
                                    value={formData.Date}
                                    onChange={(date) => onDateChanged(date)}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </ListItem>
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <TextField
                                disabled = {!project.IsOwner}
                                required
                                className={classes.text_filed_container}
                                label={s.name}
                                size="small"
                                value={formData.Name}
                                InputProps={{ endAdornment: "" }}
                                onBlur={onFormSubmitted}
                                onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                            />
                        </div>
                    </ListItem>
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <TextField
                                disabled = {!project.IsOwner}
                                multiline
                                className={classes.text_filed_container}
                                size="small"
                                label={s.description}
                                value={formData.Description}
                                onBlur={onFormSubmitted}
                                onChange={(e) => setFormData({ ...formData, Description: e.target.value })}
                            />
                        </div>
                    </ListItem>
                </List>
                <Button type="submit" style={{ display: "none" }} aria-hidden="true" tabIndex={-1} >
                    Submit
                </Button>
            </form>
        </div>
    );
};
